import { render, staticRenderFns } from "./WarehouseManage.vue?vue&type=template&id=35e5abc8&scoped=true"
import script from "./WarehouseManage.vue?vue&type=script&lang=js"
export * from "./WarehouseManage.vue?vue&type=script&lang=js"
import style0 from "./WarehouseManage.vue?vue&type=style&index=0&id=35e5abc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5abc8",
  null
  
)

export default component.exports